export default function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/utils/identity.js
// module id = 124
// module chunks = 0